<template>
  <VaLayout
    :top="{ fixed: true, order: 2 }"
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="isSidebarMinimized = true"
  >
    <template #top>
      <AppNavbar :is-mobile="isMobile" />
    </template>

    <template #left>
      <AppSidebar :minimized="isSidebarMinimized" :animated="!isMobile" :mobile="isMobile" />
    </template>

    <template #content>
      <div :class="{ minimized: isSidebarMinimized }" class="app-layout__sidebar-wrapper">
        <div v-if="isFullScreenSidebar" class="flex justify-end">
          <VaButton class="px-4 py-4" icon="md_close" preset="plain" @click="onCloseSidebarButtonClick" />
        </div>
      </div>
      <AppLayoutNavigation v-if="!isMobile" class="p-4" />
      <main class="p-4 pt-0">
        <article class="pt-4">
          <RouterView v-slot="{ Component, route }">
            <Transition name="slide-fade" mode="out-in">
              <div :key="route.name">
                <component :is="Component" />
              </div>
            </Transition>
          </RouterView>
        </article>
      </main>

      <!--footer-->
      <!--footer class="w-[100%]">
        <div class="flex h-full">
          <div class="flex bg-[#234e7b] min-w-[400px] self-stretch p-8 flex-col gap-4">
            <div class="flex flex-col max-w-[300px]">
              <RouterLink :to="{ name: 'services' }">
                <img
                  src="@/assets/iis-connect-logo-dark.png"
                  alt="Go to Home"
                  title="Belize Immigration Service Portal Logo"
                />
              </RouterLink>
            </div>
            <div class="va-text-text-inverted text-[10px] max-w-[230px]">
              Mountain View Boulevard, City of Belmopan, Cayo District, Belize C.A
            </div>
          </div>

          <div class="flex flex-col bg-[#e9e9e9] w-full self-stretch">
            <div class="p-8">
              <div class="flex justify-between gap-4">
                <div>
                  <h6 class="va-h6 text-neutral-500">Quick Links</h6>
                  <ul class="text-neutral-500 text-[12px] font-semibold">
                    <li><RouterLink :to="{ name: 'services' }">Services</RouterLink></li>
                    <li><RouterLink :to="{ name: 'TOC' }">Terms, Policies, Privacy</RouterLink></li>
                  </ul>
                </div>
                <div class="flex flex-col gap-4">
                  <div>
                    <span class="va-text-bold text-neutral-500 text-[12px]">Payments by</span>
                  </div>
                  <img
                    src="https://static.placetopay.com/placetopay-logo.svg"
                    class="w-[120px]"
                    title="Place to Pay logo"
                    alt="place to pay logo"
                  />
                </div>
              </div>
            </div>
            <div class="va-text-bold text-[.6rem] bg-[#d5d5d5] text-neutral-500 px-4 py-2">
              © 2024 Government Of Belize | Ministry of Immigration | All Rights Reserved.
            </div>
          </div>

          <div class="border-t">
            <RouterLink :to="{ name: 'TOC' }">Terms | Conditions | Privacy</RouterLink>
          </div>

          <div class="flex gap-2 px-4 py-2 text-slate-300 text-xs">

          </div>
          <div class="text-slate-300 px-4 text-xs py-3">© 2024 Government of Belize | Ministry of Immigration</div>
          <div class="text-slate-300 px-4 text-[8px] text-right">v1.0.0.0</div>

        </div>
      </footer-->
      <!--footer-->
    </template>
  </VaLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'
import { useBreakpoint, VaButton, VaLayout } from 'vuestic-ui'

import { useGlobalStore } from '@stores/global-store'

import AppLayoutNavigation from '../components/app-layout-navigation/AppLayoutNavigation.vue'
import AppNavbar from '../components/navbar/AppNavbar.vue'
import AppSidebar from '../components/sidebar/AppSidebar.vue'

const GlobalStore = useGlobalStore()

const breakpoints = useBreakpoint()

const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)

const isMobile = ref(false)
const isTablet = ref(false)
const { isSidebarMinimized } = storeToRefs(GlobalStore)

const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown
  isMobile.value = breakpoints.smDown
  isTablet.value = breakpoints.mdDown
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
  sidebarWidth.value = isTablet.value ? '100%' : '16rem'
}

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    isSidebarMinimized.value = true
  }
})

const isFullScreenSidebar = computed(() => isTablet.value && !isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  isSidebarMinimized.value = true
}
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
